<template>
  <div class="relative inline-block">
    <!-- The element that triggers the tooltip -->
    <div
      ref="referenceElement"
      class="w-fit leading-[1]"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
    >
      <slot name="reference" />
    </div>

    <!-- The tooltip itself -->
    <Transition name="fade">
      <div
        v-if="open"
        ref="floatingElement"
        class="tooltip-body"
        :style="floatingStyles"
        @mouseenter="handleMouseEnter"
        @mouseleave="handleMouseLeave"
      >
        <slot />
      </div>
    </Transition>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import {
  useFloating,
  offset,
  flip,
  shift,
  autoUpdate,
} from '@floating-ui/vue';

const props = defineProps({
  disabled: {
    type: Boolean,
    default: false,
  },
  offset: {
    type: Number,
    default: 6,
  },
});

const open = ref(false);

const referenceElement = ref(null);
const floatingElement = ref(null);

const { floatingStyles } = useFloating(
  referenceElement,
  floatingElement,
  {
    strategy: 'fixed',
    placement: 'bottom-start',
    whileElementsMounted: autoUpdate,
    middleware: [
      offset(props.offset),
      flip(),
      shift({ padding: 8 }),
    ],
  },
);

let hoverTimeout = null;

const handleMouseEnter = () => {
  if (props.disabled) return;

  if (hoverTimeout) {
    clearTimeout(hoverTimeout);
    hoverTimeout = null;
  }
  open.value = true;
};

const handleMouseLeave = () => {
  hoverTimeout = setTimeout(() => {
    open.value = false;
  }, 100);
};
</script>

<style scoped>
.tooltip-body {
  position: absolute;
  z-index: 50;
  padding: 4px 6px 4px 4px;
  background-color: #0B2C45;
  color: white;
  font-size: 12px;
  font-weight: 500;
  line-height: 1.35;

  border-radius: 3px;
  box-shadow: 0 4px 6px -1px rgb(0 0 0 / 0.1), 0 2px 4px -2px rgb(0 0 0 / 0.1);
  width: max-content;
  transition: none;
}

 .users-list-tooltip {
   .tooltip-body {
     @apply max-w-[500px]
   }
 }

.document-tooltip {
  .tooltip-body {
    @apply max-w-[300px]
  }
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.2s ease;
}

.fade-enter-from,
.fade-leave-to {
  opacity: 0;
}
</style>
